module.exports = __webpack_public_path__ + "img/client-3.287e322d.webp";